import React from 'react'
import _ from 'lodash'
import moment from 'moment'

import OrderActions from '../../actions/OrderActions.js'
import {withVehiclesHook} from '../../stores/VehicleStore.js'

import {Colors, H6, Alert, Button, Modal, ModalActions} from '../UI/index.js'
import ChooseRoutePoint from './ChooseRoutePoint.js'
import {formSpacing, ColorPicker, FormRow, FormStack, DatePicker, Input, Select, TextArea, TimePicker, Toggle} from '../UI/forms/index.js'
import NewRoute from '../../../server/functions/route/NewRoute.js'
import t from 'src/helpers/Languages.js'
import {normalizeAdjustableByMessengerGrouped, getResellerMessengerSettings} from '../../../utils/routeAdjustability.js'
import {getAvailableBranches} from 'src/utils/branches.js'

class EditRouteModal extends React.Component {
    constructor(props) {
        super(props)
        this.initialState = {
            modalIsOpen: false,
            route: NewRoute(),
            validation: {},
            loading: false,
            error: '',
            mailLoading: false,
            mailMessage: '',
            mailError: ''
        }

        this.state = structuredClone(this.initialState)
    }

    open(route, callback) {
        const {reseller} = this.props

        route = route ? structuredClone(route) : NewRoute(reseller)

        const resellerMessengerSettings = getResellerMessengerSettings(reseller.settings)
        route.adjustableByMessengerGrouped = normalizeAdjustableByMessengerGrouped(route.adjustableByMessengerGrouped)

        if (route.adjustableByMessengerGrouped === 'yes') {
            route.adjustableByMessenger = route.adjustableByMessenger ?? resellerMessengerSettings.adjustableByMessenger
            route.allowAddAddress = route.allowAddAddress ?? resellerMessengerSettings.allowAddAddress
            route.allowAddCollo = route.allowAddCollo ?? resellerMessengerSettings.allowAddCollo
            route.messengerAddOrderWarning = route.messengerAddOrderWarning ?? resellerMessengerSettings.messengerAddOrderWarning
            route.showWarningOnAddExistingOrder = route.showWarningOnAddExistingOrder ?? resellerMessengerSettings.showWarningOnAddExistingOrder
            route.allowMessengerEditCustomOptions = route.allowMessengerEditCustomOptions ?? resellerMessengerSettings.allowMessengerEditCustomOptions
        } else if (route.adjustableByMessengerGrouped === 'default') {
            route.adjustableByMessenger = route.adjustableByMessenger ?? resellerMessengerSettings.adjustableByMessenger
            route.allowAddAddress = route.allowAddAddress ?? resellerMessengerSettings.allowAddAddress
            route.allowAddCollo = route.allowAddCollo ?? resellerMessengerSettings.allowAddCollo
            route.messengerAddOrderWarning = route.messengerAddOrderWarning ?? resellerMessengerSettings.messengerAddOrderWarning
            route.showWarningOnAddExistingOrder = route.showWarningOnAddExistingOrder ?? resellerMessengerSettings.showWarningOnAddExistingOrder
            route.allowMessengerEditCustomOptions = route.allowMessengerEditCustomOptions ?? resellerMessengerSettings.allowMessengerEditCustomOptions
        } else {
            route.adjustableByMessenger = route.adjustableByMessenger ?? false
            route.allowAddAddress = route.allowAddAddress ?? false
            route.allowAddCollo = route.allowAddCollo ?? ''
            route.messengerAddOrderWarning = route.messengerAddOrderWarning ?? 'notallowed'
            route.showWarningOnAddExistingOrder = route.showWarningOnAddExistingOrder ?? false
            route.allowMessengerEditCustomOptions = route.allowMessengerEditCustomOptions ?? false
        }

        this.setState({modalIsOpen: true, route, callback})
    }

    close() {
        this.setState(this.initialState)
    }

    onChangeValue(path, parser, event) {
        const route = {...this.state.route}

        if (!event && parser) {
            event = parser
            parser = null
        }

        if (parser) {
            _.set(route, path, parser(event.target.value))
        } else {
            _.set(route, path, event.target.value)
        }

        if (path === 'vehicleTypeId') {
            const {reseller} = this.props

            const vehicleType = reseller.settings.vehicleTypes.find((vT) => vT._id === event.target.value)

            if (!vehicleType) {
                return
            }

            route.vehicleId = event.target.subvalue || ''
            route.vehicleType = vehicleType.routeProfile

            if (reseller.permissions.vehicles && vehicleType) {
                route.stopTime = vehicleType.stopTime
            }

            if (vehicleType.speedDifferenceEnabled) {
                route.customSpeed = true
                const speedDifference = vehicleType.speedDifferenceMode === 'faster' ? -parseInt(vehicleType.speedDifference) : parseInt(vehicleType.speedDifference)
                route.speedDifference = speedDifference
            }
        }

        this.setState({route})
    }

    onChangeChecked(path, event) {
        const route = {...this.state.route}

        _.set(route, path, event.target.checked)

        this.setState({route})
    }

    onSubmit(event) {
        event.preventDefault()

        const {route, callback} = this.state

        // Only the locations that can still be changed: the start is fixed once the route started, the end once it is completed
        const startMissing = !route.started && !route.completed && !route.startPoint?.position?.lat
        const endMissing = !route.completed && !route.endPoint?.position?.lat

        if (startMissing || endMissing) {
            this.setState({error: 'Vul een start- en eindlocatie in.'})
            return
        }

        if (callback) {
            callback(route)
            this.close()
            return
        }

        this.setState({loading: true, error: ''})

        if (route._id) {
            OrderActions.updateRoute(route._id, route, this.response.bind(this))
        } else {
            OrderActions.newRoute(route, this.response.bind(this))
        }
    }

    response(err) {
        if (err) {
            this.setState({error: err, loading: false})
        } else {
            this.close()
        }
    }

    render() {
        const {modalIsOpen, route, loading, error} = this.state
        const {reseller, users, vehicles} = this.props

        return (
            <Modal
                show={modalIsOpen}
                style={{width: 600}}
                title={route._id ? 'Bewerk route' : 'Nieuwe route'}
                onClose={this.close.bind(this)}
                closeButton
            >
                <FormStack style={{marginBottom: formSpacing.rowGap}}>
                    <FormRow gap={formSpacing.tight}>
                        <ColorPicker
                            value={route.color}
                            colors={Colors.routeColors}
                            onChange={this.onChangeValue.bind(this, 'color')}
                        />

                        <Input
                            label={t('name')}
                            value={route.name}
                            onChange={this.onChangeValue.bind(this, 'name')}
                        />
                    </FormRow>

                    <FormRow>
                        {getAvailableBranches(reseller).length > 0 &&
                            <Select
                                label={t('branch')}
                                value={route.branchId || ''}
                                options={getAvailableBranches(reseller).map((branch) => {
                                    return {value: branch.id, title: branch.name}
                                })}
                                onChange={this.onChangeValue.bind(this, 'branchId')}
                                allowEmpty
                            />
                        }

                        <DatePicker
                            label={t('date')}
                            value={route.date}
                            onChange={this.onChangeValue.bind(this, 'date')}
                            disabled={route._id}
                        />
                    </FormRow>

                    <FormRow>
                        <Select
                            label={t('messenger')}
                            allowEmpty
                            options={Object.values(users).map((user) => {
                                return {value: user._id, title: user.name}
                            })}
                            value={route.messengerId}
                            onChange={this.onChangeValue.bind(this, 'messengerId')}
                        />

                        <TimePicker
                            label={t('startTime')}
                            value={route.plannedStartTime}
                            readOnly={route.started || route.completed}
                            onChange={this.onChangeValue.bind(this, 'plannedStartTime')}
                        />
                    </FormRow>

                    <ChooseRoutePoint
                        label='Start:'
                        dropdownLabel='Startpunt'
                        address={route.startPoint}
                        route={route}
                        users={users}
                        routeId={route._id}
                        reseller={reseller}
                        readOnly={route.started || route.completed}
                        onChange={(startPoint) => this.setState({route: {...route, startPoint}})}
                    />

                    <ChooseRoutePoint
                        label='Eind:'
                        dropdownLabel='Eindpunt'
                        address={route.endPoint}
                        route={route}
                        users={users}
                        routeId={route._id}
                        reseller={reseller}
                        readOnly={route.completed}
                        onChange={(endPoint) => this.setState({route: {...route, endPoint}})}
                    />
                </FormStack>

                <H6 style={{marginBottom: 12, marginTop: 24}}>Voertuig</H6>

                <FormRow style={{marginBottom: formSpacing.rowGap}}>
                    <Select
                        label='Voertuig'
                        options={[
                            ...reseller.settings.vehicleTypes.filter((vT) => !vT.isArchived).map((vehicleType) => ({
                                value: vehicleType._id,
                                title: vehicleType.name,
                                icon: `mdi mdi-${vehicleType.icon}`
                            })),
                            ...vehicles.filter((v) => !v.isArchived).sort((a, b) => {
                                const unavailable = b.notAvailableDateTimeRanges?.find((range) => moment(route.date).isBetween(range.start, range.end, 'day', '[]'))

                                return unavailable ? -9999 : (a.order - b.order)
                            }).map((vehicle) => {
                                const activeVehicleType = reseller.settings.vehicleTypes.find((type) => type._id === vehicle.typeId)
                                return {
                                    value: activeVehicleType?._id || vehicle._id,
                                    ...(activeVehicleType && {subvalue: vehicle._id}),
                                    title: vehicle.name,
                                    icon: `mdi mdi-${activeVehicleType ? activeVehicleType.icon : vehicle.icon}`,
                                    disabled: vehicle.notAvailableDateTimeRanges?.find((range) => moment(route.date).isBetween(range.start, range.end, 'day', '[]'))
                                }
                            })
                        ]}
                        value={route.vehicleTypeId || reseller.settings.defaultVehicle}
                        subvalue={route.vehicleId}
                        readOnly={route.completed}
                        onChange={this.onChangeValue.bind(this, 'vehicleTypeId')}
                        groupSubvalues
                    />

                    <Input
                        type='number'
                        label='Stoptijd (seconden)'
                        value={route.stopTime}
                        readOnly={route.completed}
                        onChange={this.onChangeValue.bind(this, 'stopTime', parseInt)}
                    />
                </FormRow>

                <H6 style={{marginBottom: 12, marginTop: 24}}>Overige</H6>

                <FormStack style={{marginBottom: formSpacing.rowGap}}>
                    <TextArea
                        label='Instructie'
                        value={route.instructions}
                        onChange={this.onChangeValue.bind(this, 'instructions')}
                    />

                    <Toggle
                        style={{marginTop: 12}}
                        label='Optimaliseer voor tijdvakken'
                        checked={route.optimizeForTimeslots}
                        disabled={route.completed}
                        onChange={this.onChangeChecked.bind(this, 'optimizeForTimeslots')}
                    />

                    <Toggle
                        label={t('loadingRequiredBeforeStart')}
                        checked={route.loadingRequiredBeforeStart}
                        disabled={route.completed}
                        onChange={this.onChangeChecked.bind(this, 'loadingRequiredBeforeStart')}
                    />

                    <Select
                        label='Route aanpasbaar door koerier'
                        value={route.adjustableByMessengerGrouped}
                        disabled={route.completed}
                        onChange={this.onChangeValue.bind(this, 'adjustableByMessengerGrouped')}
                    >
                        <option value='default'>Gebruik standaard instelling</option>
                        <option value='yes'>Ja</option>
                        <option value='no'>Nee</option>
                    </Select>

                    {route.adjustableByMessengerGrouped === 'yes' &&
                        <FormStack style={{paddingLeft: formSpacing.section}}>
                            <Toggle
                                label='Route volgorde wijzigen'
                                checked={route.adjustableByMessenger}
                                disabled={route.completed}
                                onChange={this.onChangeChecked.bind(this, 'adjustableByMessenger')}
                            />

                            <Toggle
                                label='Nieuw adres aanmaken'
                                checked={route.allowAddAddress}
                                disabled={route.completed}
                                onChange={this.onChangeChecked.bind(this, 'allowAddAddress')}
                            />

                            <Toggle
                                label='Eigen opties wijzigen'
                                checked={route.allowMessengerEditCustomOptions}
                                disabled={route.completed}
                                onChange={this.onChangeChecked.bind(this, 'allowMessengerEditCustomOptions')}
                            />

                            <Select
                                label='Collo toevoegen toestaan'
                                options={[
                                    {title: 'Ja', value: 'yes'},
                                    {title: 'Alleen bij bezorgen', value: 'deliver'},
                                    {title: 'Alleen bij ophalen', value: 'pickup'},
                                    {title: 'Nee', value: ''}
                                ]}
                                value={route.allowAddCollo}
                                readOnly={route.completed}
                                onChange={this.onChangeValue.bind(this, 'allowAddCollo')}
                            />

                            <Select
                                label='Bestaande rit toevoegen aan route'
                                info='Kies hier of de koerier zelf bekende ritten kan toevoegen aan de route. Een ongeplande rit betekend een rit die niet in de route staat.'
                                value={route.messengerAddOrderWarning}
                                readOnly={route.completed}
                                onChange={this.onChangeValue.bind(this, 'messengerAddOrderWarning')}
                            >
                                <option value='notallowed'>Niet toestaan</option>
                                <option value='allowed'>Toestaan alle ritten</option>
                                <option value='only_today'>Toestaan ritten op vandaag</option>
                                <option value='only_unplanned'>Toestaan ongeplande ritten</option>
                                <option value='only_unplanned_today'>Toestaan voor ongeplande ritten op vandaag</option>
                            </Select>

                            <Toggle
                                label='Toon waarschuwing bij toevoegen bestaande rit'
                                checked={route.showWarningOnAddExistingOrder}
                                disabled={route.completed}
                                onChange={this.onChangeChecked.bind(this, 'showWarningOnAddExistingOrder')}
                            />
                        </FormStack>
                    }
                </FormStack>

                {error && <Alert style={{marginBottom: 6}} variant='danger'>{error}</Alert>}

                <ModalActions>
                    <Button loading={loading} onClick={this.onSubmit.bind(this)}>
                        Opslaan
                    </Button>
                </ModalActions>
            </Modal>
        )
    }
}

export default withVehiclesHook(EditRouteModal)
